<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'next/icon/Icon.vue';

const props = defineProps({
  phaseIndex: { type: Number, required: true },
});

const { t } = useI18n();

const PHASE_ICONS = [
  'i-lucide-building-2',
  'i-lucide-layout-grid',
  'i-lucide-mail',
  'i-lucide-rocket',
];

const phaseKey = computed(() => String(props.phaseIndex + 1));

const label = computed(() =>
  t(`ONBOARDING_WIZARD.PHASES.${phaseKey.value}.LABEL`)
);
const title = computed(() =>
  t(`ONBOARDING_WIZARD.PHASES.${phaseKey.value}.TITLE`)
);
const description = computed(() =>
  t(`ONBOARDING_WIZARD.PHASES.${phaseKey.value}.DESCRIPTION`)
);
const icon = computed(() => PHASE_ICONS[props.phaseIndex] || PHASE_ICONS[0]);
</script>

<template>
  <section
    class="w-full max-w-5xl grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center"
  >
    <div class="text-left order-2 lg:order-1">
      <p class="m-0 text-sm font-semibold text-slate-500 dark:text-slate-400">
        {{ label }}
      </p>
      <h1
        class="mt-2 mb-0 text-4xl font-bold tracking-tight text-slate-900 dark:text-white leading-tight"
      >
        {{ title }}
      </h1>
      <p
        class="mt-4 mb-0 text-lg text-slate-500 dark:text-slate-400 leading-relaxed"
      >
        {{ description }}
      </p>
    </div>

    <div
      class="order-1 lg:order-2 flex items-center justify-center min-h-[16rem]"
    >
      <div
        class="size-48 rounded-3xl bg-woot-50 dark:bg-woot-900/40 flex items-center justify-center"
      >
        <Icon :icon="icon" class="size-24 text-woot-500" />
      </div>
    </div>
  </section>
</template>
